import bubbleUtils from './BubblesUtils';

const screamBubbleUtils = {
    minCogWidth: 10,
    maxCogWidth: 10,
    minCogHeight: 5,
    maxCogHeight: 10,
    cornerCogOffset: 5,

    getPath (shapeModel) {
        const points = this.getPoints(shapeModel);
        const path  = this.createPath(points, shapeModel);

        return path;
    },
    createPath (points, shapeModel) {
        var data = `M${points[0].x - shapeModel.x},${points[0].y - shapeModel.y}`;
        const length = points.length;
        var i;
        var point;

        for (i=1; i<length; i++) {
            point = points[i];
            point.x = point.x - shapeModel.x;
            point.y = point.y - shapeModel.y;
            data += 'L' + point.x + ',' + point.y;
        }

        return data;
    },
    getNextStep (point, shapeModel, direction) {
        const {x, y, width, height} = shapeModel;
        const minX = Math.min(x, x + width) + this.cornerCogOffset;
        const maxX = Math.max(x, x + width) - this.cornerCogOffset;
        const minY = Math.min(y, y + height) + this.cornerCogOffset;
        const maxY = Math.max(y, y + height) - this.cornerCogOffset;
        let nextStep;

        switch (direction) {
            case 'right': {
                nextStep = this.randomIntFromInverval(this.minCogWidth, this.maxCogWidth) + point.x;

                if (nextStep < maxX) {
                    if( (maxX - nextStep) < this.cornerCogOffset) {
                        nextStep = maxX;
                    }

                    return {x: nextStep, y: point.y};
                } else {
                    return {x:maxX, y:minY};
                }
                break;
            }
            case 'down':
            {
                nextStep = this.randomIntFromInverval(this.minCogWidth, this.maxCogWidth) + point.y;

                if (nextStep < maxY) {
                    if(maxY - nextStep < this.cornerCogOffset) {
                        nextStep = maxY;
                    }

                    return {x:point.x, y:nextStep};
                } else {
                    return {x:maxX, y:maxY};
                }

                break;
            }
            case 'left':
            {
                nextStep = point.x - this.randomIntFromInverval(this.minCogWidth, this.maxCogWidth);

                if (nextStep > minX) {
                    if (nextStep - minX < this.cornerCogOffset) {
                        nextStep = minX;
                    }

                    return {x:nextStep, y:point.y};
                } else {
                    return {x:minX, y:maxY};
                }

                break;
            }
            case 'up':
            {
                nextStep = point.y - this.randomIntFromInverval(this.minCogWidth, this.maxCogWidth);

                if (nextStep > minY) {
                    if (nextStep - minY < this.cornerCogOffset) {
                        nextStep = minY;
                    }

                    return {x:point.x, y:nextStep};
                } else {
                    return {x:minX, y:minY};
                }

                break;
            }
        }
    },
    getPoints (shapeModel) {
        const x = Math.min(shapeModel.x, shapeModel.x + shapeModel.width);
        const y = Math.min(shapeModel.y, shapeModel.y + shapeModel.height);
        const width = Math.abs(shapeModel.width);
        const height = Math.abs(shapeModel.height);

        // Variables that hold the index of the cog that will become a control point.
        let firstRight = -1;
        let lastRight = -1;
        let firstDown = -1;
        let lastDown = -1;
        let firstLeft = -1;
        let lastLeft = -1;
        let firstUp = -1;
        let lastUp = -1;

        let direction = 'right';
        let currentPoint = {x: x + this.cornerCogOffset, y:y};
        let points = [];

        points.push(currentPoint);

        do {
            let nextPoint = this.getNextStep(currentPoint, shapeModel, direction);
            let cogTip;

            switch(direction) {
                case 'right': {
                    cogTip = {x: (currentPoint.x + nextPoint.x) / 2, y: currentPoint.y - this.randomIntFromInverval(this.minCogHeight, this.maxCogHeight)};

                    points.push(cogTip);

                    if (firstRight == -1) {
                        firstRight = points.length - 1;
                    }

                    lastRight = points.length - 1;

                    points.push(nextPoint);

                    if (nextPoint.x == x + width - this.cornerCogOffset) {
                        direction = 'down';

                        points.push({x: x + width + this.maxCogHeight,y: y - this.maxCogHeight});
                        points.push({x: x + width,y: y + this.cornerCogOffset});

                        nextPoint = {x: x + width,y: y + this.cornerCogOffset};

                        firstDown = points.length;
                    }
                    break;
                }
                case 'down': {
                    cogTip = {x: currentPoint.x + this.randomIntFromInverval(this.minCogHeight, this.maxCogHeight),y: (currentPoint.y + nextPoint.y) / 2};

                    points.push(cogTip);
                    lastDown = points.length - 1;

                    points.push(nextPoint);

                    if (nextPoint.y == y + height - this.cornerCogOffset) {
                        direction = 'left';

                        points.push({x:x + width + this.maxCogHeight,y: y + height + this.maxCogHeight});
                        points.push({x:x + width - this.cornerCogOffset,y: y + height});

                        nextPoint = {x:x + width - this.cornerCogOffset,y: y + height};

                        firstLeft = points.length;
                    }
                    break;
                }
                case 'left': {
                    cogTip = {x:(currentPoint.x + nextPoint.x) / 2,y: currentPoint.y + this.randomIntFromInverval(this.minCogHeight, this.maxCogHeight)};

                    points.push(cogTip);
                    lastLeft = points.length - 1;

                    points.push(nextPoint);

                    if (nextPoint.x == x + this.cornerCogOffset) {
                        direction = 'up';

                        points.push({x:x - this.maxCogHeight,y:y + height + this.maxCogHeight});
                        points.push({x,y: y + height - this.cornerCogOffset});

                        nextPoint = {x,y: y + height - this.cornerCogOffset};

                        firstUp = points.length;
                    }
                    break;
                }
                case 'up':{
                    cogTip = {x: currentPoint.x - this.randomIntFromInverval(this.minCogHeight, this.maxCogHeight),y: (currentPoint.y + nextPoint.y) / 2};

                    points.push(cogTip);
                    lastUp = points.length - 1;

                    points.push(nextPoint);

                    if (nextPoint.y == y + this.cornerCogOffset) {
                        direction = 'right';

                        points.push({x: x - this.maxCogHeight,y: y - this.maxCogHeight});
                        points.push({x: x + this.cornerCogOffset, y});

                        nextPoint = {x, y};
                    }
                    break;
                }
            }

            currentPoint = nextPoint;
        } while( currentPoint.x != x || currentPoint.y != y);

        // add Stem position

        const currentSector = bubbleUtils.getActiveSector(shapeModel, {x: shapeModel.cx, y: shapeModel.cy});

        var newIndex = -1;
        var step = 2;

        switch(currentSector) {
            case 1: {
                newIndex = lastDown - step;
                break;
            }
            case 2: {
                newIndex = firstLeft + step;
                break;
            }
            case 3: {
                newIndex = lastLeft - step;
                break;
            }
            case 4: {
                newIndex = firstUp + step;
                break;
            }
            case 5: {
                newIndex = lastUp - step;
                break;
            }
            case 6: {
                newIndex = firstRight + step;
                break;
            }
            case 7: {
                newIndex = lastRight - step;
                break;
            }
            case 8: {
                newIndex = firstDown + step;
                break;
            }
        }

        if (points[newIndex]) {
            points[newIndex].x = shapeModel.cx;
            points[newIndex].y = shapeModel.cy;
        }

        return points;
    },
    randomIntFromInverval (min, max) {
        return Math.floor(Math.random()*(max-min+1)+min);
    }
};

export default screamBubbleUtils;



/** WEBPACK FOOTER **
 ** ./src/components/slide/shapes/utils/ScreamBubbleUtils.js
 **/